import React from "react";

const SelectAllContext = React.createContext();

export default SelectAllContext;
